<template>
  <div class="notif" :class="[direction]">
    <div class="icon"></div>
    <div class="date">{{ formatDate(appointment.date) }}</div>
    <div class="content">
      <slot>
        <h4>Rendez-vous "{{ title }}" {{ formatDateTime(appointment.date) }}</h4>
      </slot>
      <p v-if="appointment.comment">{{ appointment.comment }}</p>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Bouton from '@/components/Bouton'
  import { formatDate, formatDateTime } from '@/functions'
  import BadgesDB from '@/datas/badges.json'
  import SoignantDB from '@/datas/soignants.json'

  const appointmentTypes = {
    medecin: "Rendez-vous médecin",
    kine: "Rendez-vous kinésithérapeute",
    diet: "Rendez-vous diététicien.ne",
    psy: "Rendez-vous psychologue",
    infirmiere: "Rendez-vous infirmièr.e à domicile",
    visiteur: "Rendez-vous visiteur",
    chimio: "Séance de chimiothérapie",
    myelogramme: "Myélogramme",
    transfusion: "Transfusion sanguine",
    'voie-veineuse': "Pose de voie veineuse centrale",
    conditionnement: "Préparation à la greffe",
    other: "Autres",
  }

  export default {
    props: ['direction', 'appointment'],
    data() {
      return { BadgesDB, SoignantDB }
    },
    components: { Bouton },
    computed: {
      ...mapState(['me']),
      title() {
        if (this.appointment.title) {
          return this.appointment.title
        }
        return appointmentTypes[this.appointment.appointment_type]
      }
    },
    methods: {
      formatDate,
      formatDateTime
    }
  }
</script>

<style>
  .notif {
    position: relative;
    display: inline-block;
    width: 100%;
    margin-bottom: 130px;
  }
  .notif .date {
    padding: 7px 15px;
    background: #CCC;
    display: inline;
    border-radius: 10px;
    font-size: 14px;
    color: white;
    font-weight: 600;
    position: absolute;
    top: 50%;
    margin-top: -17px;
  }
  .notif .content {
    background: white;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.3);
    border-radius: 15px;
    padding: 20px;
    width: 450px;
    text-align: left;
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 10px;
  }
  .notif .content:before,
  .notif .content:after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 20px 15px 0;
    border-color: transparent #e2e2e2 transparent transparent;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .notif .content:after {
    border-color: transparent #fff transparent transparent;
  }
  .notif .content h4 {
    margin: 0 0 10px;
    font-size: 19px;
  }
  .notif .content p {
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 10px;
  }
  .notif .icon {
    display: inline-block;
    background: #c3c3c3;
    border: 3px solid #a28f8f;
    width: 55px;
    height: 55px;
    border-radius: 150px;
    color: white;
    font-size: 24px;
    text-align: center;
    padding: 6px;
  }
  .notif .icon:before {
    content: "\f073";
    font-family: "Font Awesome 5 Free";
    display: inline-block;
    position: relative;
    font-weight: 900;
  }

  /* Les types et couleurs */

  .notif.date .date {  background: #de2128; }
  .notif.date .icon {  background: #de2128; border-color: #7f0004;  }
  .notif.date .icon:before { content: "\f073"; }

  .notif.alerte .date { background: #086fab;  }
  .notif.alerte .icon { background: #086fab; border-color: #403592;  }
  .notif.alerte .icon:before { content: "\f0f3"; }
  .notif.alerte .btnPush { background: #086fab;box-shadow: 0px 8px 0px 0px #403592;  }
  .notif.alerte .btnPush:hover { box-shadow: 0px 0px 0px 0px #403592;  }

  .notif.message .date {  background: #4dde44; }
  .notif.message .icon {  background: #4dde44; border-color: #139a0a;  }
  .notif.message .icon:before { content: "\f075"; }
  .notif.message .btnPush { background: #4dde44;box-shadow: 0px 8px 0px 0px #139a0a;  }
  .notif.message .btnPush:hover { box-shadow: 0px 0px 0px 0px #139a0a;  }

  .notif.game .date {  background: #e3e039; color: #414141;}
  .notif.game .icon {  background: #e3e039; border-color: #c2b81b;  }
  .notif.game .icon:before { content: "\f005";color: #414141;}
  .notif.game .btnPush { background: #e3e039;box-shadow: 0px 8px 0px 0px #c2b81b;color: #414141;  }
  .notif.game .btnPush:hover { box-shadow: 0px 0px 0px 0px #c2b81b;  }


  .notif.badge .date { background: #e3e039; color: #414141; }
  .notif.badge .icon { background: #e3e039; border-color: #9f9d12; }
  .notif.badge .icon:before { content: "\f0a3" }

  /* Alignement */

  .notif.right .date {
    left: 50%;
    margin-left: -180px;
  }
  .notif.right .content:before,
  .notif.right  .content:after {
    left: -20px;
  }
  .notif.right .content:after {
    left: -18px;
  }
  .notif.left .date {
    right: 50%;
    margin-right: -180px;
  }
  .notif.left .content {
    margin-left: -515px;
    text-align: right;
  }
  .notif.left .content .btnPush {
    margin-right: 0px;
  }
  .notif.left .content:before,
  .notif.left  .content:after {
    border-width: 15px 0 15px 20px;
    border-color: transparent transparent transparent #e2e2e2;
    right: -20px;
  }
  .notif.left .content:after {
    border-color: transparent transparent transparent #fff;
    right: -18px;
  }
</style>
